module.exports = __webpack_public_path__ + "static/media/workout_science.6deb127a.webp";